import type { HTMLAttributes } from "react";
import { cn } from "../cn";

/* 1:1 with discordforge.org skeletons (ExpertCollections.tsx,
 * PremiumCheckout.tsx):
 *   animate-pulse bg-white/5 border border-white/5 rounded-3xl
 * (also seen: bg-white/[0.03] rounded-[32px]) */
export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
    /** Rounded-ness. Default rounded-2xl (fits cards); use "sm" for avatars. */
    radius?: "sm" | "md" | "lg" | "full";
}

const RADIUS_CLASSES = {
    sm: "rounded-lg",
    md: "rounded-2xl",
    lg: "rounded-[32px]",
    full: "rounded-full",
};

export function Skeleton({ className, radius = "md", ...rest }: SkeletonProps) {
    return (
        <div
            aria-hidden
            className={cn(
                "animate-pulse border border-white/5 bg-white/5",
                RADIUS_CLASSES[radius],
                className
            )}
            {...rest}
        />
    );
}
